import type {
  AutocompleteGroupResultFilter,
  AutocompleteTopicResultFilter,
  AutocompleteUserResultFilterType,
} from '@ms/yammer-graphql';
import { AutocompleteOfficeGroupResultFilter } from '@ms/yammer-graphql';

import type { Group, TypeaheadResults, User } from '../../state/types';

interface GetIdParams {
  readonly search: string;
  readonly type: keyof TypeaheadResults;
  readonly groupIds?: Group['id'][];
  readonly userResultFilters?: AutocompleteUserResultFilterType[];
  readonly groupResultFilter?: AutocompleteGroupResultFilter;
  readonly topicResultFilter?: AutocompleteTopicResultFilter;
  readonly officeGroupResultFilter?: AutocompleteOfficeGroupResultFilter;
  readonly contextGroupId?: Group['id'];
  readonly onBehalfOfUserId?: User['id'];
}

type GetId = (parameters: GetIdParams) => string;
export const getId: GetId = ({
  search,
  type,
  groupIds,
  userResultFilters,
  groupResultFilter,
  topicResultFilter,
  officeGroupResultFilter,
  contextGroupId,
  onBehalfOfUserId,
}) => {
  const officeGroupsFilterValue = officeGroupResultFilter ?? AutocompleteOfficeGroupResultFilter.EXCLUDE_M365_GROUPS;

  switch (type) {
    case 'groups':
      return `${type}-${search.toLowerCase()}-groupResultFilter:${groupResultFilter}-senderId:${onBehalfOfUserId}`;
    case 'users':
      return `${type}-${search.toLowerCase()}-groupIds:${groupIds ? groupIds.join(',') : 'undefined'}-userResultFilters:${userResultFilters ? userResultFilters.join(',') : 'undefined'}`;
    case 'topics':
      return `${type}-${search.toLowerCase()}-topicResultFilter:${topicResultFilter}`;
    case 'officeGroups':
      return `${type}-${search.toLowerCase()}-officeGroupResultFilter:${officeGroupsFilterValue}`;
    case 'campaignReferences':
      return `${type}-${search.toLowerCase()}-contextGroupId:${contextGroupId}`;
  }
};
